













































































































































































import {Vue, Component, Prop} from "vue-property-decorator";
import QuestionTooltip from "@/components/question_components/QuestionTooltip.vue";
import {
    UserInputStandardType,
    StandardQuestionType
} from "@/types/surveyTab.type";

@Component({
    components: {
        QuestionTooltip
    }
})
export default class StandardQuestion extends Vue {
    @Prop() value!: UserInputStandardType;
    @Prop() question!: StandardQuestionType;
    @Prop() nextClicked!: boolean;

    hover = false;
    commentEditMode = false;

    // function to set error status.
    checkAnswer(value: UserInputStandardType) {
        if (value.answer == null && this.nextClicked) {
            return true;
        } else {
            return false;
        }
    }

    commentAction() {
        // Add Comment
        if (this.value.comments === null && this.commentEditMode == false) {
            this.value.comments = "";
            this.commentEditMode = true;
        }
        //Delete Comment
        else if (this.commentEditMode && this.value.comments !== null) {
            this.value.comments = null;
            this.commentEditMode = false;
        }
        // Set Edit mode
        else if (!this.commentEditMode && this.value.comments !== null) {
            this.commentEditMode = true;
        }
    }

    freezeComment() {
        if (this.value.comments !== null && this.value.comments !== "") {
            this.commentEditMode = false;
        } else if (this.value.comments == "") {
            this.value.comments = null;
            this.commentEditMode = false;
        }
    }

    setAnswer(question: string) {
        this.$emit("setAnswer", question);
    }

    resetAnswer() {
        this.value.answer = null;
        this.$emit("reset");
    }

    get commentSet() {
        if (this.value.comments == null) {
            return false;
        } else return true;
    }

    get showBookmarker() {
        if (this.hover || this.value.bookmarked) {
            return true;
        } else return false;
    }
}
